// extracted by mini-css-extract-plugin
module.exports = {"actionBlock":"ActionBlock_actionBlock__2XR0l","text":"ActionBlock_text__PdnTj","button":"ActionBlock_button__3dzkN"};